import _ from "lodash";
import { useState } from "react";
import { DataTable } from "../ui/DataTable";
import { Box, Button, IconButton, Typography } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { IndicatorModal } from "./IndicatorModal";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckIcon from "@mui/icons-material/Check";
import { createConfirm } from "../../utils/confirm";

export const IndicatorInlineList = ({ value = [], onChange }) => {
  const [data, setData] = useState(value);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);

  const handleAddNew = () => {
    setModalData(null);
    setShowModal(true);
  };

  const handleDataMutation = (oldData, newData) => {
    if (oldData) {
      const index = _.findIndex(data, { id: oldData.id });
      data[index] = newData;
    } else {
      data.push(newData);
    }
    setData([...data]);
    onChange(data);
  };

  const handleDelete = (indicator) => {
    createConfirm("Are you sure you want to delete this indicator?", {
      customClass: {
        container: "indicator-delete-confirm-popup",
      },
    })
      .fire({})
      .then((result) => {
        if (result.isConfirmed) {
          const newData = data.filter((item) => item !== indicator);

          setData(newData);
          onChange(newData);
        }
      });
  };

  return (
    <Box width={"100%"}>
      <IndicatorModal
        showModal={showModal}
        setShowModal={setShowModal}
        editData={modalData}
        onDataMutation={handleDataMutation}
      />
      <Box
        width={"100%"}
        sx={{
          mb: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "end",
        }}
      >
        <Typography>All indicators will be repeated for each group</Typography>
        <Button
          variant="contained"
          size="small"
          title="Add an indicator"
          startIcon={<AddCircleIcon />}
          color="success"
          onClick={handleAddNew}
        >
          Add Indicator
        </Button>
      </Box>
      <DataTable
        rows={data}
        columns={[
          {
            headerName: "Name",
            field: "name",
            flex: 1,
          },
          {
            headerName: "Sum",
            field: "sum",
            maxWidth: 100,
            cellRenderer: (params) => {
              return params.data.useFormula === false ? <CheckIcon /> : "";
            },
          },
          {
            headerName: "Formula",
            field: "formula",
            maxWidth: 100,
            cellRenderer: (params) => {
              return params.data.useFormula === true ? <CheckIcon /> : "";
            },
          },
          {
            headerName: "Order",
            field: "displayOrder",
            maxWidth: 100,
            cellRenderer: (params) => {
              return <span>{params.data.displayOrder || "-"}</span>;
            },
          },
          {
            headerName: "Actions",
            field: "actions",
            maxWidth: 130,
            cellRenderer: (params) => {
              return (
                <Box sx={{ display: "flex" }}>
                  <IconButton
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      setModalData(params.data);
                      setShowModal(true);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="warning"
                    onClick={() => handleDelete(params.data)}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              );
            },
          },
        ]}
        rowHeight={40}
        height={250}
        fullHeight={false}
        showExport={false}
        showFullScreen={false}
        agGridProps={{
          cellSelection: false,
          suppressCellFocus: true,
          defaultColDef: { suppressHeaderMenuButton: true },
        }}
      />
    </Box>
  );
};
